define("ember-cli-clipboard/components/copy-button", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object/internals", "ember-arg-types", "prop-types"], function (_exports, _component, _templateFactory, _component2, _internals, _emberArgTypes, _propTypes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/object/internals",0,"ember-arg-types",0,"prop-types"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <button
    class='copy-btn'
    type={{this.buttonType}}
    data-clipboard-id={{this.guid}}
    ...attributes
    {{clipboard
      text=this.text
      target=this.target
      action=this.action
      delegateClickEvent=this.delegateClickEvent
      container=this.container
      onError=this.onError
      onSuccess=this.onSuccess
    }}
  >
    {{yield}}
  </button>
  */
  {
    "id": "o3Eunba7",
    "block": "[[[11,\"button\"],[24,0,\"copy-btn\"],[16,4,[30,0,[\"buttonType\"]]],[16,\"data-clipboard-id\",[30,0,[\"guid\"]]],[17,1],[4,[38,0],null,[[\"text\",\"target\",\"action\",\"delegateClickEvent\",\"container\",\"onError\",\"onSuccess\"],[[30,0,[\"text\"]],[30,0,[\"target\"]],[30,0,[\"action\"]],[30,0,[\"delegateClickEvent\"]],[30,0,[\"container\"]],[30,0,[\"onError\"]],[30,0,[\"onSuccess\"]]]]],[12],[1,\"\\n  \"],[18,2,null],[1,\"\\n\"],[13]],[\"&attrs\",\"&default\"],false,[\"clipboard\",\"yield\"]]",
    "moduleName": "ember-cli-clipboard/components/copy-button.hbs",
    "isStrictMode": false
  }); // eslint-disable-next-line ember/no-classic-components


  let CopyButtonComponent = (_dec = (0, _emberArgTypes.arg)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func])), _dec2 = (0, _emberArgTypes.arg)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func])), _dec3 = (0, _emberArgTypes.arg)((0, _propTypes.oneOf)(['copy', 'cut'])), _dec4 = (0, _emberArgTypes.arg)(_propTypes.boolean), _dec5 = (0, _emberArgTypes.arg)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])), _dec6 = (0, _emberArgTypes.arg)(_propTypes.string), _dec7 = (0, _emberArgTypes.arg)(_propTypes.boolean), _dec8 = (0, _emberArgTypes.arg)(_propTypes.boolean), (0, _emberArgTypes.forbidExtraArgs)(_class = (_class2 = class CopyButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "guid", (0, _internals.guidFor)(this));

      _initializerDefineProperty(this, "text", _descriptor, this);

      _initializerDefineProperty(this, "target", _descriptor2, this);

      _initializerDefineProperty(this, "action", _descriptor3, this);

      _initializerDefineProperty(this, "delegateClickEvent", _descriptor4, this);

      _initializerDefineProperty(this, "container", _descriptor5, this);

      _initializerDefineProperty(this, "buttonType", _descriptor6, this);

      _initializerDefineProperty(this, "onError", _descriptor7, this);

      _initializerDefineProperty(this, "onSuccess", _descriptor8, this);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "text", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "action", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "delegateClickEvent", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "container", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "buttonType", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'button';
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "onError", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "onSuccess", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class2)) || _class);
  _exports.default = CopyButtonComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CopyButtonComponent);
});